"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Image = void 0;
class Image {
}
exports.Image = Image;
//# sourceMappingURL=Image.js.map